import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';

import EmailSubscribeBox from 'Components/EmailSubscribe/EmailSubscribeBox';
import JoinCommunity from 'Components/Account/AccountOverview/JoinCommunity';
import store from 'Redux/store';

import 'Components/Account/AccountOverview/MarketingBlock.scss';


const MarketingBlock = ({ siteTheme }) => {
  const reduxStore = store.getState();
  const newsletterSubscribed = get(reduxStore, 'auth.email_newsletter', false);

  if (!newsletterSubscribed) {
    return <EmailSubscribeBox large lightTheme={siteTheme === 'light'} context="Blog post page" />;
  }

  return <JoinCommunity />;
};

MarketingBlock.propTypes = {
  siteTheme: PropTypes.string,
};

MarketingBlock.defaultProps = {
  siteTheme: '',
};

export default MarketingBlock;
